export default {
  // Index
  notifications: {
    english: "Notifications",
    spanish: "Notificaciones",
  },
  noNotifications: {
    english: "No notifications",
    spanish: "No hay notificaciones",
  },
  newNotification: { english: "New notification", spanish: "Nueva notificación" },
  notification: { english: "Notification", spanish: "Notificación" },
  activateToViewDetails: { english: "Activate to view details.", spanish: "Activar para ver los detalles." },
};
